import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Fade from 'react-reveal/Fade'

const BrandIntro = ({ title = '', content = '', logo = null }) => {
  return (
    <section className='category-archive category-archive--brand-intro'>
      <div className='category-archive__inner'>
        <Fade bottom distance={'40px'}>
          <div className='category-archive__header'>
            {logo?.localFile && <GatsbyImage className='category-archive__logo' loading='lazy' image={getImage(logo.localFile)} alt={title} />}
            {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
            {content && <div className='category-archive__header-content' dangerouslySetInnerHTML={{ __html: content }} />}
          </div>
        </Fade>
      </div>
    </section>
  )
}

export default BrandIntro